/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS python filter api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PointGeometry } from './PointGeometry';
import {
  PointGeometryFromJSON,
  PointGeometryFromJSONTyped,
  PointGeometryToJSON,
} from './PointGeometry';

/**
 *
 * @export
 * @interface BaseGrounding
 */
export interface BaseGrounding {
  /**
   * Unique identifier for the record
   * @type {number}
   * @memberof BaseGrounding
   */
  id?: number | null;
  /**
   * Universal unique identifier for the record
   * @type {string}
   * @memberof BaseGrounding
   */
  uuid?: string | null;
  /**
   * Created at this point in time
   * @type {Date}
   * @memberof BaseGrounding
   */
  createdAt?: Date | null;
  /**
   * Created by this user
   * @type {string}
   * @memberof BaseGrounding
   */
  createdBy?: string | null;
  /**
   * Modified at this point in time
   * @type {Date}
   * @memberof BaseGrounding
   */
  modifiedAt?: Date | null;
  /**
   * Modified by this user
   * @type {string}
   * @memberof BaseGrounding
   */
  modifiedBy?: string | null;
  /**
   * MMSI of the vessel
   * @type {number}
   * @memberof BaseGrounding
   */
  mmsi: number;
  /**
   *
   * @type {PointGeometry}
   * @memberof BaseGrounding
   */
  groundingPoint: PointGeometry;
  /**
   * Time of the grounding
   * @type {string}
   * @memberof BaseGrounding
   */
  groundingTime: Date;
  /**
   * Time of the release from grounding
   * @type {string}
   * @memberof BaseGrounding
   */
  releaseTime?: Date | null;
  /**
   * Name of the vessel
   * @type {string}
   * @memberof BaseGrounding
   */
  vesselName?: string | null;
  /**
   * IMO of the vessel
   * @type {number}
   * @memberof BaseGrounding
   */
  imo?: number | null;
  /**
   * Call sign of the vessel
   * @type {string}
   * @memberof BaseGrounding
   */
  callSign?: string | null;
  /**
   *
   * @type {Array<number>}
   * @memberof BaseGrounding
   */
  configurationIds?: Array<number>;
}

/**
 * Check if a given object implements the BaseGrounding interface.
 */
export function instanceOfBaseGrounding(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && 'mmsi' in value;
  isInstance = isInstance && 'groundingPoint' in value;
  isInstance = isInstance && 'groundingTime' in value;

  return isInstance;
}

export function BaseGroundingFromJSON(json: any): BaseGrounding {
  return BaseGroundingFromJSONTyped(json, false);
}

export function BaseGroundingFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): BaseGrounding {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, 'id') ? undefined : json['id'],
    uuid: !exists(json, 'uuid') ? undefined : json['uuid'],
    createdAt: !exists(json, 'created_at')
      ? undefined
      : json['created_at'] === null
      ? null
      : new Date(json['created_at']),
    createdBy: !exists(json, 'created_by') ? undefined : json['created_by'],
    modifiedAt: !exists(json, 'modified_at')
      ? undefined
      : json['modified_at'] === null
      ? null
      : new Date(json['modified_at']),
    modifiedBy: !exists(json, 'modified_by') ? undefined : json['modified_by'],
    mmsi: json['mmsi'],
    groundingPoint: PointGeometryFromJSON(json['grounding_point']),
    groundingTime: json['grounding_time'],
    releaseTime: !exists(json, 'release_time')
      ? undefined
      : json['release_time'],
    vesselName: !exists(json, 'vessel_name') ? undefined : json['vessel_name'],
    imo: !exists(json, 'imo') ? undefined : json['imo'],
    callSign: !exists(json, 'call_sign') ? undefined : json['call_sign'],
    configurationIds: !exists(json, 'configuration_ids')
      ? undefined
      : json['configuration_ids'],
  };
}

export function BaseGroundingToJSON(value?: BaseGrounding | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    uuid: value.uuid,
    created_at:
      value.createdAt === undefined
        ? undefined
        : value.createdAt === null
        ? null
        : value.createdAt.toISOString(),
    created_by: value.createdBy,
    modified_at:
      value.modifiedAt === undefined
        ? undefined
        : value.modifiedAt === null
        ? null
        : value.modifiedAt.toISOString(),
    modified_by: value.modifiedBy,
    mmsi: value.mmsi,
    grounding_point: PointGeometryToJSON(value.groundingPoint),
    grounding_time: value.groundingTime,
    release_time: value.releaseTime,
    vessel_name: value.vesselName,
    imo: value.imo,
    call_sign: value.callSign,
    configuration_ids: value.configurationIds,
  };
}
